import { defineComponent, inject } from "vue";
import LanguageIcon from "../../common/Language.vue.mjs";
import SwitchTheme from "../../common/SwitchTheme.vue.mjs";
import RoomInfo from "../RoomInfo/index.mjs";
import LayoutControl from "./LayoutControl.vue.mjs";
import NetworkInfo from "./NetworkInfo.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "index",
  setup(__props) {
    const showHeaderInfo = inject("showHeaderInfo", true);
    return { __sfc: true, showHeaderInfo, Language: LanguageIcon, SwitchTheme, RoomInfo, LayoutControl, NetworkInfo };
  }
});
export {
  _sfc_main as default
};
